<div class="flex w-full justify-center">
  <p-panel class="p-panel-with-green-header m-6 block max-w-[30rem]">
    <ng-template pTemplate="header">
      <div class="flex items-center gap-2">
        <span class="font-bold">{{ 'errorpage.message.forbidden' | translate }}</span>
      </div>
    </ng-template>
    <p>
      {{ 'errorpage.message.forbidden.description' | translate }}
      <a href="/">{{ 'errorpage.message.forbidden.description.login' | translate }}</a
      >.
    </p>
  </p-panel>
</div>
